export default {
  clientLogo: store => store.clientLogo,
};
